<template>
  <div>
    <a-card class="customer-filter" size="small">
      <test-plan-filter-form v-model="filterForm" :project-id="projectId" @change="onSearch" @reset="reset" />
    </a-card>
    <a-card title="计划列表" size="small" class="filter-data">
      <span slot="extra">
        <a-button v-tc="{ name: '添加' }" class="handle-menu" type="link" icon="plus" @click="onAdd">添加</a-button>
      </span>
      <test-plan-data-list category="testplan" :loading="loading" :table-data="tableData" :pagination="pagination" @page-change="handleTableChange" @edit="onEdit" @copy="onCopy" @add-case="onAddCase" @reload="getPlanList" />
    </a-card>
    <test-plan-modal :is-show="modalVisible" :plan-id="planId" @close="close" />
    <case-selector :is-show="caseSelectorVisible" :plan-bind-keys="planBindCases" :ok-loading="okLoading" @close="closeSelector" />
  </div>
</template>

<script>
import { testPlanList, bindTestCases, planBindCaseIds, testPlanCopy } from '@/api/project/testPlan';

import TestPlanFilterForm from '@/pages/project/testplan/components/TestPlanFilterForm';
import TestPlanDataList from '@/pages/project/testplan/components/TestPlanDataList';
import TestPlanModal from '@/pages/project/testplan/components/TestPlanModal';
import CaseSelector from '@/pages/project/testplan/components/CaseSelector';

export default {
  name: 'Index',
  components: {
    TestPlanFilterForm,
    TestPlanDataList,
    TestPlanModal,
    CaseSelector
  },
  data() {
    return {
      projectId: parseInt(this.$route.params.project_id) || null,
      planId: null,
      modalVisible: false,
      loading: false,
      tableData: [],
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: this.$store.getters.pageSize,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: total => `共 ${total} 条`
      },
      filterForm: {
        name: '',
        time_field: 'start_time'
      },
      okLoading: false,
      planBindCases: [],
      caseSelectorVisible: false
    };
  },
  mounted() {
    this.getPlanList();
  },
  methods: {
    getPlanList() {
      this.loading = true;
      testPlanList({
        ...this.filterForm,
        project_id: this.projectId,
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current
      })
        .then(res => {
          this.tableData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onAdd() {
      this.modalVisible = true;
      this.planId = null;
    },
    onEdit(record) {
      this.planId = record.id;
      this.modalVisible = true;
    },
    onCopy(record) {
      testPlanCopy({ test_plan_id: record.id }).then(() => {
        this.$message.success('复制计划成功');
        this.getPlanList();
      });
    },
    onAddCase(plan) {
      this.planId = plan.id;
      planBindCaseIds({ test_plan_id: this.planId }).then(res => {
        this.planBindCases = res.data.items;
        this.caseSelectorVisible = true;
      });
    },
    close() {
      this.planId = null;
      this.modalVisible = false;
      this.getPlanList();
    },
    handleTableChange(pagination) {
      pagination.current = pagination.pageSize !== this.pagination.pageSize ? 1 : pagination.current;
      this.pagination = pagination;
      this.getPlanList();
    },
    reset() {
      this.filterForm = {
        name: '',
        page_size: 10,
        page_number: 1,
        time_field: 'start_time'
      };
      this.pagination.current = 1;
      this.pagination.pageSize = this.$store.getters.pageSize;
      this.getPlanList();
    },
    onSearch(filter) {
      this.filterForm = { ...filter };
      this.pagination.current = 1;
      this.getPlanList();
    },
    closeSelector(targetKeys = null) {
      if (targetKeys !== null) {
        this.bindCases(targetKeys);
      } else {
        this.caseSelectorVisible = false;
      }
    },
    bindCases(testCases) {
      this.okLoading = true;
      bindTestCases({ test_plan_id: this.planId, cases: testCases })
        .then(() => {
          this.okLoading = false;
          this.caseSelectorVisible = false;
          this.$message.success('关联用例成功');
        })
        .catch(() => {
          this.okLoading = false;
          this.caseSelectorVisible = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .customer-filter {
  .ant-page-header {
    padding: 0;
  }

  margin-bottom: 16px;
}
</style>
